let inject = ['$scope', '$uibModalInstance','modalOptions'];

class ModalResponseController {
  constructor ($scope,$uibModalInstance,modalOptions) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = Object.assign({}, modalOptions);
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close(this.$scope);
  }
}

ModalResponseController.$inject = inject;

export default ModalResponseController;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/modal-response/modal-response.controller.js
 **/